import { init, captureException } from '@umengfe/apm'
import { APPKEY, IGNORE_ERROR } from './constants'
import { IsMobile } from '..'

export const umengInit = (app: any) => {
  const env = window?.checkEnv() === 'prod' ? 'PROD' : 'TEST'
  const payload = {
    pid: APPKEY[env],
    tag: IsMobile() ? 'phone' : 'web',
    errorFilter: {
      mode: 'ignore',
      rules: IGNORE_ERROR,
    },
  }
  init(payload)

  app.config.errorHandler = (err: any) => {
    console.error('err', err)
    captureException(err)
  }
}

/**
 * sendAPILog的method映射表
 */
const LOG_METHODS = {
  GET: 1,
  POST: 2,
  PUT: 3,
  HEAD: 4,
  DELETE: 5,
  CONNECT: 6,
  OPTIONS: 7,
  TRACE: 8,
  PATCH: 9,
}

/**
 * 友盟u-web事件映射表，记录事件类型
 * 用于手动记录需要跟踪的事件，一些特定的错误，或者异常都可以使用该map
 */
const EVENT_MAP = {
  BUSINESS_EVENT: '_businessEvent', // 业务事件
  JS_CUSTOM_EVENT: '_jsCustomEvent', // JS异常
}


export { LOG_METHODS, EVENT_MAP }
